import { render, staticRenderFns } from "./IlamBilgileriInfo.vue?vue&type=template&id=7ec429c8&scoped=true"
import script from "./IlamBilgileriInfo.vue?vue&type=script&lang=ts"
export * from "./IlamBilgileriInfo.vue?vue&type=script&lang=ts"
import style0 from "./IlamBilgileriInfo.vue?vue&type=style&index=0&id=7ec429c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec429c8",
  null
  
)

export default component.exports